
import { ProgressSpinnerModule } from 'primeng/progressspinner';


import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewEncapsulation,isDevMode
} from '@angular/core';
import { Observable, of as observableOf,Subject,BehaviorSubject } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {
  faCoffee,faLessThanEqual,
  faCopy,faFileUpload,
  faCloudUploadAlt,faTimes,
  faCheck,faTrashAlt,
  faEdit,faSearch,
  faVideo,faFilePdf,faFile, 
  faThumbsDown, faEye, faPlus,
  faCalendar, faFileArchive,
  faBox,faPlay,faCalendarDay,
  faSpinner, faExclamationTriangle,


  
} from '@fortawesome/free-solid-svg-icons';
import {
  KeycloakProfile
} from 'keycloak-js';
import {
  KeycloakService
} from 'keycloak-angular';
import {
  environment
} from '../../environments/environment';
import {
  SkipperService
} from '../services/skipper.service';
interface trayItem {
  date;
  size;
  fileName;
  shortID;
  fileType;
}

import {MessageService} from 'primeng/api';
import { Table, TableModule } from 'primeng/table';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
import { TooltipModule } from 'primeng/tooltip';
import { error } from '@angular/compiler/src/util';

interface selectedItem {
  total_records;
  id;
  id_usuario;
  tipo_acto;
  id_juzgado;
  descripcion_juzgado;
  numero_expediente;
  relevancia;
  condicion;
  descripcion;
  vencimiento;
  fecha_vencimiento;
  fecha_guardado;
  archivo;
  tipo_archivo;
  bucket;
  id_s3;
  size;
  short_id_group;
  short_id;  
  error_conversion;
}
interface FileTypes {
  name: String
}
interface Tipo {
  name: String,
    code: String
}
interface Juzgado {
  name: String,
    code: String
}
interface Usuario {
  id_usuario: string,
  nombre: string,
  apellido: string
}

interface Estado {
  id: string,
  descripcion: string
}

@Component({
  selector: 'app-sent-tray',
  templateUrl: './sent-tray.component.html',
  styleUrls: ['./sent-tray.component.scss']
})

export class SentTrayComponent implements AfterViewInit, OnInit {
  @ViewChild('table') table: Table;
  dateFrom: Date;
  dateTo: Date;
  numeroExpediente='';
  copiedClipConfirmed=false
  es: any;
  tipos: Tipo[] = [];
  juzgados: Juzgado[] = [];
  selectedTipo: Tipo;
  selectedJuzgado: Juzgado;
  userDetails: KeycloakProfile;
  sessionToken='';
  juzgadosFilterDrop:Juzgado[]=[];
  loadingSentTrayTable=true;
  faTrashAlt=faTrashAlt;faEdit=faEdit;faCopy=faCopy;
  faSearch=faSearch;faVideo=faVideo;faEye=faEye;
  faFilePdf=faFilePdf;faFile=faFile;faTimes=faTimes;
  faPlus=faPlus;faCheck=faCheck;
  faCalendar=faCalendar;faFileArchive=faFileArchive;
  faBox=faBox;faPlay=faPlay;faCalendarDay=faCalendarDay;
  faSpinner=faSpinner; progressSpinnerModule=ProgressSpinnerModule;
  faExclamationTriangle=faExclamationTriangle;


  selectedDetailFile:selectedItem;
  selectedValueVisibilidad='todos';
  selectedFileTypes:FileTypes[];
  selectedTableRow;
  filters={};
  URLParamSeparator=environment.URL_PARAMETER_SEPARATOR_DOWNLOAD;
  URLDownloader=environment.URL_DOWNLOADER;
  displayDetailSideBar=false;
  descripcion_input='';
  nombre_archivo=''
  expiryFrom: Date;
  expiryTo: Date;
  fileTypes: FileTypes[] = [{
    "name": "Video"
  }, {
    "name": "Pdf"
  },
  {
    "name": "Office"
  }]

  dpdnUsuarios: Usuario[]  = [];
  dpdnUsuarioSelected: Usuario = undefined;

  dpdnEstados: Estado[]  = [];
  dpdnEstadoSelected: Estado = undefined;
  
  val: number = undefined;

  displaySideBarDeleteDetails = false;
  isFileDeleted: boolean = false;
  inputTextMotivoBorrado: string = '';
  tipoArchivo: string = '';
  documentVideoSelected: any = '';
  disabledDeleteComponents: boolean = false;
  showProgressSpinner: boolean = false;
  
  totalRecordsSentTray=0
  userConfigMissing=false
  private isLoggedInObserver = new BehaviorSubject("false");
  NO_META4_USER=environment.NO_META4_USER_MESSAGE
  elementType = 'url';
  value = 'Techiediaries';

  files:trayItem[]

  dialogShow: boolean = false;
  currentEntity: selectedItem = undefined;
  
  @ViewChild('input') input: ElementRef;
  @ViewChild('bar') bar: ElementRef;
  // @ViewChild('ourForm', {static: true}) ourForm;
  ngAfterViewInit() {
    if(isDevMode()) console.log("table after view init");
    
    if(isDevMode()) console.log(this.table)
    // if(isDevMode()) console.log(this.input.nativeElement.innerHTML);
  }
  constructor(private keycloakService: KeycloakService,
      private changeDetection: ChangeDetectorRef,
      private skipperService:SkipperService,
      private sanitizer:DomSanitizer,
      private messageService:MessageService
    ) {
    }

  async doLogout() {
    await this.keycloakService.logout();
  }

  async ngOnInit() {

    this.dpdnEstados.push( { id: 'activo', descripcion: 'Activos' } );
    this.dpdnEstados.push( { id: 'borrado', descripcion: 'Borrados' } );
    this.dpdnEstados.push( { id: 'todo', descripcion: 'Todos' } );
    this.dpdnEstadoSelected = this.dpdnEstados.find(x => x.id == 'activo');

    this.es = {
      firstDayOfWeek: 1,
      dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      dayNamesMin: [ "D","L","M","M","J","V","S" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      today: 'Hoy',
      clear: 'Borrar'

    }

    if (await this.keycloakService.isLoggedIn()) {
      if(isDevMode()) console.log("logged in!!");
      
      this.userDetails = await this.keycloakService.loadUserProfile();
      this.sessionToken= await this.keycloakService.getToken();
      if(isDevMode()) console.log(this.userDetails['username'])
      this.isLoggedInObserver.next("true")
    
    }

    this.skipperService.getJuzgados().subscribe(r=>{
      let tarr=[]
      for (let a = 0; a < r['data'].length; a++) {
        tarr.push({"name":r['data'][a]['cod_nomenclador']+'-'+r['data'][a]['descripcion'],"code":r['data'][a]['id'],"cod_nomenclador":r['data'][a]['cod_nomenclador']});  
        //tarr['cod_nomenclador']=r['data'][a]['cod_nomenclador'];
        }
    if(isDevMode()) console.log(tarr);
    this.juzgados=tarr
    })

    this.skipperService.getTiposActos().subscribe(r=>{
      let respArr=[]
      for (let a =0; a< r['data'].length;a++)
      {
        respArr.push({"name":r['data'][a]['descripcion'],"code":r['data'][a]['id']})
      }
      this.tipos=respArr

    })

    this.skipperService.getUsuarios().subscribe(r=>{
      if(r['error_code']!=undefined && r['error_code']=='err-06')
      {
        this.userConfigMissing=true

      }else
      {
      for (let i = 0; i < r['data'].length; i++) {
        r['data'][i].nombre_apellido = r['data'][i].nombre + ' ' + r['data'][i].apellido + ' (' + r['data'][i].id_usuario + ')' ;
      }
      this.dpdnUsuarios = r['data'];
      }
    })

    this.dialogShow = false;
  
  }

  searchJuzgadosDrop(query)
  {
   // this.juzgadosFilterDrop=this.juzgados
    if(isDevMode()) console.log(query);
  let q=query.query
  let temp =this.juzgados.filter(function( obj ) {
    return obj['name'].toLowerCase().includes(q.toLowerCase());
  });
  this.juzgadosFilterDrop = [...temp]
  if(isDevMode()) console.log(this.juzgadosFilterDrop)
  }

async loadTrayLazy(evt)
{
  this.loadingSentTrayTable=true
  if(isDevMode()) console.log('EVENT LAZY')
  if(isDevMode()) console.log(evt)
  if(isDevMode()) console.log(this.numeroExpediente);
  //this.filters={}
if(this.filters['clear']!=undefined)
{
//clear when user presses quitar filtros.
this.nombre_archivo=''
this.descripcion_input=''
this.selectedDetailFile=undefined
this.dateTo=undefined
this.dateFrom=undefined
this.expiryTo=undefined
this.expiryFrom=undefined
this.selectedJuzgado=undefined
this.numeroExpediente=""
this.selectedTipo=undefined
this.selectedValueVisibilidad='todos'
this.dpdnUsuarioSelected = undefined;
this.dpdnEstadoSelected = this.dpdnEstados.find(x => x.id == 'activo');
this.val = undefined;
this.filters={}
}else
{

  if(this.dpdnUsuarioSelected)
  {
    this.filters["id_usuario"] = this.dpdnUsuarioSelected.id_usuario;
  } else {
    this.filters["id_usuario"] = undefined;
  }

  this.filters["estado"] = this.dpdnEstadoSelected.id;

  if(this.selectedValueVisibilidad!=undefined)
  {
    this.filters["condicion"]=this.selectedValueVisibilidad
  }
  if(this.descripcion_input!=undefined || this.descripcion_input!=='')
  {
    this.filters["descripcion"]=this.descripcion_input
  } else {
    this.filters["descripcion"]=''
  }
  if(this.nombre_archivo!=undefined || this.nombre_archivo!=='')
  {
    this.filters["nombre_archivo"]=this.nombre_archivo
  } else {
    this.filters["nombre_archivo"]=''
  }
  if(this.numeroExpediente.trim()!=='')
  {
    this.filters["numero_expediente"]=this.numeroExpediente
  } else {
    this.filters["numero_expediente"]=''
  }
  if(this.selectedTipo!=undefined)
  {
    this.filters["tipo_acto"]=this.selectedTipo.name
  } else {
    this.filters["tipo_acto"]=undefined
  }
  if(this.val!=undefined)
  {
    this.filters["relevancia"]=this.val
  } 
  if(this.selectedJuzgado!=undefined)
  {
    this.filters["id_juzgado"]=this.selectedJuzgado.code;
  }
  if(this.dateFrom!=undefined)
  {
    let date=new Date(this.dateFrom)
    let y=date.getFullYear()
    let m=date.getMonth()+1
    let d=date.getDate()
    let dstr=''
    let mstr=''
    if(d<10){dstr="0"+d.toString()}else{dstr=d.toString()}
    if(m<10){mstr="0"+m.toString()}else{mstr=m.toString()}
    this.filters['fecha_guardado_desde']=y+"/"+mstr+"/"+dstr
  }
  if(this.dateTo!=undefined)
  {
    let date=new Date(this.dateTo)
    let y=date.getFullYear()
    let m=date.getMonth()+1
    let d=date.getDate()
    let dstr=''
    let mstr=''
    if(d<10){dstr="0"+d.toString()}else{dstr=d.toString()}
    if(m<10){mstr="0"+m.toString()}else{mstr=m.toString()}
    this.filters['fecha_guardado_hasta']=y+"/"+mstr+"/"+dstr
  }
  if(this.expiryFrom!=undefined)
  {
    let date=new Date(this.expiryFrom)
    let y=date.getFullYear()
    let m=date.getMonth()+1
    let d=date.getDate()
    let dstr=''
    let mstr=''
    if(d<10){dstr="0"+d.toString()}else{dstr=d.toString()}
    if(m<10){mstr="0"+m.toString()}else{mstr=m.toString()}
    this.filters['fecha_vencimiento_desde']=y+"/"+mstr+"/"+dstr
  }
  if(this.expiryTo!=undefined)
  {
    let date=new Date(this.expiryTo)
    let y=date.getFullYear()
    let m=date.getMonth()+1
    let d=date.getDate()
    let dstr=''
    let mstr=''
    if(d<10){dstr="0"+d.toString()}else{dstr=d.toString()}
    if(m<10){mstr="0"+m.toString()}else{mstr=m.toString()}
    this.filters['fecha_vencimiento_hasta']=y+"/"+mstr+"/"+dstr
  }
}



this.isLoggedInObserver.subscribe(r=>{
    if(isDevMode()) console.log("from subscribe")
    if(isDevMode()) console.log(r);
  
    if (r=='true')
    {
    //this.filters['id_usuario']=this.userDetails['username']
    this.filters['first']=evt.first
    this.filters['rows']=evt.rows
    if(isDevMode()) console.log("filters")
    if(isDevMode()) console.log(this.filters)
    this.skipperService.getUploadedFiles(this.filters).subscribe(r=>{
      if(isDevMode()) console.log(r)
      let recs=r['data']
      if(recs!==undefined && recs.length>0)
      {

        for (let i = 0; i < recs.length; i++) {
          //  if(isDevMode()) console.log('---');
          //  if(isDevMode()) console.log(recs[i]);

          if (recs[i].estado == 'activo') {
            //  if(isDevMode()) console.log('ACTIVO');
            recs[i].estado_activo = true;
            
          } else {
            //  if(isDevMode()) console.log('BORRADO');
            recs[i].estado_activo = false;
          }
        }

        if(isDevMode()) console.log("got inside loading blobk");
        if(isDevMode()) console.log(recs);

        this.totalRecordsSentTray=recs[0]['total_records']
        this.files=recs
        this.loadingSentTrayTable=false
      }else{
        this.totalRecordsSentTray=0
        this.files=[]
        this.loadingSentTrayTable=false
      }
    })
  }
})

}

filtersTriggered(state)
{
  if (state=='apply')
  {
    if(isDevMode()) console.log("filters triggered")
    this.table.reset();
  }
  if (state=='remove')
  {
    //need to wipe out all filter values
    if(isDevMode()) console.log("filters cleared");
    this.filters['clear']='yeah'
    this.table.reset();
  }
  
}

copyRowData(data)
  {
    var textArea = document.createElement("textarea");
    let textBody=''
    textBody+= "Documento: "+data['archivo']
    textBody+= "\nDescripción: "+data['descripcion']
    textBody+= "\nTamano: "+(data['size']/1000/1000).toFixed(3) +' MBytes'
    textBody+= "\nIdentificador: "+data['short_id']
    textBody+= "\nIdentificador de Grupo: "+data['short_id_group']
    textBody+= "\nCondición: "+data['condicion']
    textBody+= "\nN° de Expediente: "+data['numero_expediente']
    textBody+='\nSubido por: '+data['id_usuario']
    textBody+='\nFecha de subido: '+data['fecha_guardado']
    if (data['estado_activo']) {
      textBody+='\nEstado: Activo'
      textBody+='\nLink de acceso: '+this.assemble_single_link(data)
    } else {
      textBody+='\nEstado: Borrado'
      textBody+='\nBorrado por: '+data['estado']['borrado']['id_usuario']
      textBody+='\nEl día: '+data['estado']['borrado']['fecha_borrado']
      textBody+='\nMotivo: '+data['estado']['borrado']['motivo']
    }
    
    if(isDevMode()) console.log(data);
    textArea.value = textBody;
    
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
  
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
  
    try {
      var successful = document.execCommand('copy');
      //this.confirmCopied = successful ;
      //this.confirmCopied=true
      this.copiedClipConfirmed=true
      this.messageService.add({severity:'success',summary:'Texto Copiado',detail:data['archivo']})
      
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
  
    document.body.removeChild(textArea);
  }

  loadDetail(file)
  {
    this.selectedDetailFile=file
    this.displayDetailSideBar=true
    this.copiedClipConfirmed=false
  }



  onRowSelect(e)
  {
    if(isDevMode()) console.log("selected")
    if(isDevMode()) console.log(e.data) 
    this.selectedDetailFile=e.data
    this.displayDetailSideBar=true
    this.copiedClipConfirmed=false
    this.selectedDetailFile['isCopied2Clip']=false
  }


  onRowUnselect(e)
  {
    if(isDevMode()) console.log("unselected")
    if(isDevMode()) console.log(e.data)
   // this.selectedDetailFile=undefined
  }


  editFile(file)
  {
    if(isDevMode()) console.log(file);
  }

  assemble_single_link(file)
  {
    if(file.condicion=='publico-descarga-directa')
    {
      return environment.BACK_DIRECT_DOWNLOAD+file.short_id
    }
    if(file.condicion!=='publico-descarga-directa')
    {
      return this.URLDownloader+file.short_id
    }

  }

sanitize(condicion, short_id_type){
  
  if (short_id_type == 'short_id') {
    if (condicion=='publico-descarga-directa'){ this.selectedDetailFile["sanitized_url"]=this.sanitizer.bypassSecurityTrustUrl(environment.BACK_DIRECT_DOWNLOAD+this.selectedDetailFile.short_id);}
    if (condicion!=='publico-descarga-directa'){ this.selectedDetailFile["sanitized_url"]=this.sanitizer.bypassSecurityTrustUrl(this.URLDownloader+this.selectedDetailFile.short_id);}
  } else {
    if (condicion=='publico-descarga-directa') { 
      this.selectedDetailFile["sanitized_url"] = this.sanitizer.bypassSecurityTrustUrl(this.URLDownloader+this.selectedDetailFile.short_id_group);
    }
    if (condicion!=='publico-descarga-directa') { 
      this.selectedDetailFile["sanitized_url"] = this.sanitizer.bypassSecurityTrustUrl(this.URLDownloader+this.selectedDetailFile.short_id_group);
    }
  
  }
  
  return this.selectedDetailFile["sanitized_url"]
} 

sanitize_HTML(condicion){
  if (condicion=='publico-descarga-directa'){ this.selectedDetailFile["sanitized_url"]=this.sanitizer.bypassSecurityTrustHtml(environment.BACK_DIRECT_DOWNLOAD+this.selectedDetailFile.short_id);}
  if (condicion!=='publico-descarga-directa'){ this.selectedDetailFile["sanitized_url"]=this.sanitizer.bypassSecurityTrustHtml(this.URLDownloader+this.selectedDetailFile.short_id);}
  
  return this.selectedDetailFile["sanitized_url"]
}

plain_link(condicion, short_id_type){
  if (short_id_type == 'short_id') {
    if (condicion=='publico-descarga-directa'){ this.selectedDetailFile["sanitized_url"]=environment.BACK_DIRECT_DOWNLOAD+this.selectedDetailFile.short_id}
    if (condicion!=='publico-descarga-directa'){ this.selectedDetailFile["sanitized_url"]=this.URLDownloader+this.selectedDetailFile.short_id}
  } else {
    if (condicion=='publico-descarga-directa') { 
      this.selectedDetailFile["sanitized_url"] = '';
    }
    if (condicion!=='publico-descarga-directa') { 
      this.selectedDetailFile["sanitized_url"] = this.URLDownloader+this.selectedDetailFile.short_id_group;
    }
 
  }
  
  return this.selectedDetailFile["sanitized_url"]
}

  loadSideBarDeleteDetails(par_file) {

    this.displaySideBarDeleteDetails = true;
    this.inputTextMotivoBorrado = '';
    this.documentVideoSelected = par_file;
    this.disabledDeleteComponents = false;

    if (par_file.estado_activo) {
      this.tipoArchivo = par_file.tipo_archivo == 'document' ? 'documento' : 'video';
      this.isFileDeleted = false;
    } else {
      this.tipoArchivo = par_file.tipo_archivo == 'document' ? 'Documento' : 'Video';
      this.isFileDeleted = true;
    }
  }



  deleteDocumentVideo() {

    if (!this.inputTextMotivoBorrado) {
      this.messageService.add({severity:'warn',summary:'',detail:'Debe ingresar el motivo por el que el ' + this.tipoArchivo + ' será borrado'})
    } else {

      this.disabledDeleteComponents = true;
      this.showProgressSpinner = true;

      this.skipperService.deleteDocumentVideo(this.documentVideoSelected.id, this.inputTextMotivoBorrado).subscribe(
        result => {

          if (!result['error_code']) {
            // si no hay error

            this.table.reset();
            this.displaySideBarDeleteDetails = false;
            this.showProgressSpinner = false;
          } else {
            // si hay error
            this.messageService.add({severity:'warn', summary:'', detail: 'Se produjo un error'});
            this.displaySideBarDeleteDetails = false;
            this.showProgressSpinner = false;
          }
        },
        error => {
          this.messageService.add({severity:'warn', summary:'', detail: 'Se produjo un error'});
          this.displaySideBarDeleteDetails = false;
          this.showProgressSpinner = false;
      }
      )
    }
  }


  entityAction( par_entity) {

    this.currentEntity = par_entity;
    this.dialogShow = true;
  }

  resetDT(dt: TableModule) {

    dt['first'] = 0
    this.loadTrayLazy({})
  }



  onHideDialog() {
      this.resetDT(this.table);
  }


  closeSession()
  {
    this.skipperService.closeSession()
  }


  isWMVFile(fileWMV): boolean {
   
      return fileWMV.includes('.wmv');

    
  }



  errorConversion(): boolean {
    if (this.selectedDetailFile) {
      console.log("error_conversion:", this.selectedDetailFile.error_conversion);
      return this.selectedDetailFile.error_conversion === true;
    } else {
      return false;
    }

  }

   
  
}

  // errorConversion = (errorConvert: boolean) => errorConvert === true;

//   errorConversionWMVdetected(errorConversion?: boolean): boolean {
    
    
//     return !!errorConversion;
    


  
// }


// GET Parametros: >> 
// id_usuario: devuelve todas las filas con el usuario dado. Busqueda =. Obligatorio.  
// >> tipo_acto: devuelve todas las filas con el tipo de acto dado. 
// Busqueda = >> id_juzgado: devuelve todas filas con el id_juzgado dado. 
// Busqueda = >> numero_expediente: devuelve todas las filas con el número de expediente dado.
// Busqueda like >> condicion: parámetros válidos: [publico, privado]. si el valor indicado no es correcto o '' devuelve todos 
// >> fecha_guardado_desde: en formato yyyy/mm/dd. si la fecha indicada es posterior a hoy, asigna hoy devuelve todas las filas con fecha_guardado posterior o igual a esta fecha 
// >> fecha_guardado_hasta: en formato yyyy/mm/dd. si la fecha indicada es posterior a hoy, asigna hoy devuelve todas las filas con fecha_guardado anterior o igual a esta fecha 
// >> nombre_archivo: devuelve todas las filas con el nombre de archivo dado.
//  Busqueda like >> tipo_archivo: parámetros válidos: [document, video]. si el valor indicado no es correcto o '' devuelve todos
// >> sortfield: campo de ordenamiento de las filas devueltas. Orden predeterminado: fecha_guardado
// >> sortorder: orden de las filas devueltas. Predeterminado -1 (descendente)
// >> limit: para paginado. Cantidad de filas devueltas. Si no se pasa, devuelve de a 10 filas
// >> skip: para paginado. Fila desde la que devuelve. Si no se pasa, devuelve desde la fila 0